import { render, staticRenderFns } from "./CustomerContactFormGroup.vue?vue&type=template&id=345e0ae6"
import script from "./CustomerContactFormGroup.vue?vue&type=script&lang=js"
export * from "./CustomerContactFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports